import React, { useState, useEffect } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { translate } from "../../Services/translation";

const ResellerZipCodeToCoordinates = ({setZipLatLong}) => {
  const geocoding = useMapsLibrary("geocoding"); 
  const [zipCode, setZipCode] = useState(window.localStorage.getItem("storeListZipCode") || "");
  const [showEnterZipMessage, setShowEnterZipMessage] = useState(false);
  const [noResult, setNoResult] = useState(false);
  const [geocoder, setGeocoder] = useState(null);

  useEffect(() => {
    if (geocoding) {
      setGeocoder(new geocoding.Geocoder());
    }
  }, [geocoding]);

  useEffect(async () => {
    if (zipCode !== "") {
      await getZipCodeCoordinates();
    }
  }, [geocoder])

  const getCurrentPositionCoordinates = () => {
    navigator.geolocation.getCurrentPosition((position) => { 
      setZipLatLong({ latitude: position.coords.latitude, longitude: position.coords.longitude })
    });
    setZipCode("");
    window.localStorage.setItem("storeListZipCode", "");
    setShowEnterZipMessage(false);
    setNoResult(false);
  }

  const getZipCodeCoordinates = async () => {
    if (zipCode !== "") {
      window.localStorage.setItem("storeListZipCode", zipCode);
      if (!geocoder) return;
      geocoder.geocode({ address: zipCode, componentRestrictions: { country: window.__litium.constants.currentCountry } }, (results, status) => {
        const postCodeResults = results.filter((result) => result.types.includes("postal_code"));
        if (status === "OK" && postCodeResults.length > 0) {
          const { lat, lng } = postCodeResults[0].geometry.location;
          console.log(results)
          setZipLatLong({ latitude: lat(), longitude: lng() });
          setNoResult(false);
        } else {
          setNoResult(true);
          setZipLatLong({})
          console.error("Geocoding failed:", status);
        }
      });
    } else {
      setShowEnterZipMessage(true);
    }
  };

  return (
    <>
      <div className="get-location">
        <label htmlFor="zip-input">{translate('brenderup.storelist.zip')}</label>
        <form onSubmit={(e) => {
          e.preventDefault(); 
          getZipCodeCoordinates();
        }}>
          <input
            id="zip-input"
            type="text"
            placeholder={translate('brenderup.storelist.zipplaceholder')}
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value.replace(" ", ""))}
          />
          <button type="submit">
            {translate('brenderup.storelist.findstoresfromzip')}
          </button>
        </form>
        { showEnterZipMessage && zipCode.length === 0 && (
          <p className="invalid">{translate('brenderup.storelist.enterzipwarning')}</p>
        )}
        { noResult && (
          <p className="invalid">{translate('brenderup.storelist.noresult')}</p>
        )}
      </div>
      <div className="get-current-location">
        <button onClick={getCurrentPositionCoordinates}>
          {translate('brenderup.storelist.findstoresfromlocation')}
        </button>
      </div>
    </>
  );
};

export default ResellerZipCodeToCoordinates;